var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0V0C18.6274 0 24 5.37258 24 12V12C24 18.6274 18.6274 24 12 24V24C5.37258 24 0 18.6274 0 12V12Z",
    fill: "#F15A4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0381 8.02251L16.2426 7.22702L12 11.4697L7.75736 7.22702L6.96186 8.02251L11.2045 12.2652L7.22703 16.2426L8.02252 17.0381L12 13.0606L15.9775 17.0381L16.773 16.2426L12.7955 12.2652L17.0381 8.02251Z",
    fill: "#979797"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_108_53261",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 7,
    width: 12,
    height: 11
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0381 8.02251L16.2426 7.22702L12 11.4697L7.75736 7.22702L6.96186 8.02251L11.2045 12.2652L7.22703 16.2426L8.02252 17.0381L12 13.0606L15.9775 17.0381L16.773 16.2426L12.7955 12.2652L17.0381 8.02251Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_108_53261)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.75,
    y: -0.75,
    width: 25.5,
    height: 25.5,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.608f48c9e22db3f140f0dcb19280ef97.svg";
export { ForwardRef as ReactComponent };